<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';

export default {
    page: {
        title: "Category",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Category",
            items: [
                {
                text: "Device Management",
                href: "/",
                },
                {
                text: "Category",
                active: true,
                },
            ],
        
            categoryList:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
        };
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY H:m:s')
            }
        },
        getCategoryList(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'category/list')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.categoryList = response.data;
                    console.log(this.categoryList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
    },

    mounted() {
        this.getCategoryList();
        
    },
    
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!--button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModalgrid"  v-if="this.role = 1">Add New Category</button> <br><br-->
        <div class="card">
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable class="table table-striped table-nowrap mb-0"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>No.</th>
                                            <th scope="col">Name</th>           
                                            <th scope="col">Status</th>
                                            <th scope="col">Created Date</th>
                                            <th scope="col">Created By</th>
                                            <!--th scope="col">Action</th-->
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in categoryList" :key="index" class="content">
                                            <td>{{ index+1 }}</td>                               
                                            <td>{{ item.name }}</td>
                                            <td v-if="item.status == 0"><span class="badge bg-success">Active</span></td>
                                            <td v-else><span class="badge bg-danger">Disabled</span></td>
                                            <td>{{ format_date(item.created_at) }}</td>                                          
                                            <td>{{ item.user_name }}</td>                                          
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>